const utils = {
  cardScroll: (leftRef, leftRef1, setFixed, setBottom) => {
    if (leftRef && leftRef.current && leftRef.current.clientHeight) {
      const refHeight = leftRef.current.clientHeight - 100;
      const refHeight1 = leftRef1.current.clientHeight + 120;

      if (window.scrollY >= refHeight1 && window.scrollY < refHeight) {
        setFixed(2);
      } else if (window.scrollY >= refHeight) {
        setFixed(3);
      } else {
        setFixed(1);
      }

      if (window.scrollY >= document.body.offsetHeight - 1500) {
        setBottom(true);
      } else {
        setBottom(false);
      }
    }
  },
  esteelauder: {
    en: 1,
    'zh-cn': 42,
    zh_cn: 42,
    ja: 6,
    fr: 24,
    ko: 153,
    de: 99,
    es: 117,
    it: 135,
    tr: 1,
    id: 1,
    ru: 1,
    pt: 1,
  },
  benefit: {
    en: 2,
    'zh-cn': 43,
    zh_cn: 43,
    ja: 11,
    fr: 25,
    ko: 154,
    de: 100,
    es: 118,
    it: 136,
    tr: 2,
    id: 2,
    ru: 2,
    pt: 1,
  },
  elf: {
    en: 21,
    'zh-cn': 50,
    zh_cn: 50,
    fr: 34,
    ko: 160,
    de: 106,
    tr: 21,
    id: 21,
    ru: 21,
    pt: 21,
  },
  isInFrame: () => {
    return window.location.pathname.indexOf('/iframe') !== -1;
  },
  getFreeTrialUrl: productTypes => {
    // Priority: skin > simulation > makeup > eyewear
    const priorityMapping = [
      // Skin Analysis
      {
        products: new Set([
          'P04_AR_SKIN_DIAGNOSTIC',
          'P05_IN_STORE_BARCODE_TRY_ON',
          'P07_LIVE_AR_FOR_CORPORATE_TRAINING',
          'P08_LIVE_STREAMING_FOR_BRANDS',
          'P09_LIVE_HAIR_COLOR',
          'P11_PRODUCT_RECOMMENDATION',
          'P17_VIRTUAL_TRY_ON_FOR_NAILS',
          'P25_AI_PERSONALITY_FINDER',
          'P26_AR_HAIRSTYLE_VIRTUAL_TRY_ON',
        ]),
        url: '/business/user/free-trial?functionType=SKINCARE_PRO',
      },
      // Simulation
      {
        products: new Set([
          'P15_FACE_ANALYZER',
          'P24_AI_FACE_RESHAPE_SIMULATOR',
          'P27_AI_SKIN_EMULATION',
        ]),
        url:
          '/business/user/free-trial?functionType=SKINCARE_PRO&solutionType=AESTHETIC_SIMULATION',
      },
      // Makeup
      {
        products: new Set([
          'P01_VIRTUAL_MAKEUP',
          'P02_AI_SMART_SHADE_FINDER',
          'P03_AI_FACIAL_RECOGNITION',
          'P06_BEAUTY_ADVISOR_1_ON_1',
          'P10_VIRTUAL_ACCESSORIES',
          'P13_YOUCAM_TUTORIAL',
          'P23_AI_VIRTUAL_BACKGROUND_CHANGER',
        ]),
        url: '/business/user/free-trial',
      },
      // Eyewear
      {
        products: new Set([
          'P14_VIRTUAL_EYEWEAR',
          'P16_AI_BEARD_DYE',
          'P18_AR_VIRTUAL_RING_TRY_ON',
          'P19_AR_BRACELET_VIRTUAL_TRY_ON',
          'P20_AR_WATCH_VIRTUAL_TRY_ON',
          'P21_AR_EARRING_VIRTUAL_TRY_ON',
          'P22_AI_NECKLACE_VIRTUAL_TRY_ON',
        ]),
        url: '/business/user/free-trial?functionType=EYEWEAR',
      },
    ];

    const matchedCategory = priorityMapping.find(category =>
      productTypes.some(type => category.products.has(type))
    );

    return matchedCategory
      ? matchedCategory.url
      : '/business/user/free-trial?functionType=SKINCARE_PRO';
  },
};

export default utils;
